import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FC } from 'react';
import { BlogAuthorDto, BlogPostDto } from '@/components/BlogPage/types';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import css from './style.module.scss';
interface Props {
  person: BlogAuthorDto;
  currentPost: BlogPostDto;
  label?: string;
}
const PersonCard: FC<Props> = t0 => {
  const $ = _c(22);
  const {
    person,
    currentPost,
    label: t1
  } = t0;
  const label = t1 === undefined ? "Author" : t1;
  if (!person) {
    return null;
  }
  const {
    name,
    role,
    avatar,
    seo
  } = person;
  const t2 = `/blog/author/${seo.url}`;
  let t3;
  if ($[0] !== currentPost.seo.url) {
    t3 = {
      from: currentPost.seo.url
    };
    $[0] = currentPost.seo.url;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      pathname: t2,
      query: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== avatar || $[6] !== name) {
    t5 = avatar?.url ? <Image src={avatar.url} width={82} height={82} className={css.avatar} alt={name} /> : null;
    $[5] = avatar;
    $[6] = name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== label) {
    t6 = <Typography uppercase={true} responsive={false} variant="body-s" tag="p" className={css.authorLabel}>{label}</Typography>;
    $[8] = label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== name) {
    t7 = <Typography variant="body-m" tag="p" responsive={false} className={css.name}>{name}</Typography>;
    $[10] = name;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== role) {
    t8 = role ? <Typography variant="body-m" tag="p" responsive={false} className={css.role}>{role}</Typography> : null;
    $[12] = role;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className={css.infoWrapper}>{t6}{t7}{t8}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t9) {
    t10 = <Link className={css.personCard} href={t4}>{t5}{t9}</Link>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default PersonCard;